import { useState, useEffect, useRef } from 'react';
import api from './api';
import { useAuth } from './AuthContext';

export function Messages() {
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState('');
    const wsRef = useRef(null);
    const { user } = useAuth();

    useEffect(() => {
        api.get('/messages').then((res) => setMessages(res.data));

        const ws = new WebSocket(process.env.REACT_APP_WS_URL);
        wsRef.current = ws;

        ws.onmessage = (event) => {
            const msg = JSON.parse(event.data);
            setMessages((prev) => [...prev, msg]);
        };

        return () => ws.close();
    }, []);

    const sendMessage = async (e) => {
        e.preventDefault();
        if (!text.trim()) return;

        const res = await api.post('/messages', { content: text });
        const msg = { ...res.data, username: user.username };

        if (wsRef.current?.readyState === 1) {
            wsRef.current.send(JSON.stringify(msg));
        }

        setText('');
    };

    return (
        <div className="messages-page">
            <h2>Messages</h2>
            <div className="messages-list">
                {messages.map((m, i) => (
                    <div key={m.id || i} className="message-item">
                        <strong>{m.username}</strong>: {m.content}
                    </div>
                ))}
            </div>
            <form onSubmit={sendMessage} className="send-message-form">
                <input
                    placeholder="Type a message..."
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />
                <button type="submit">Send</button>
            </form>
        </div>
    );
}
